/* Menu Fix: in the drawer menu, the plus button toggles the submenu and the label link navigates. */
(() => {
  if (window.__menuDrawerParentToggle) return;
  window.__menuDrawerParentToggle = true;

  const TOGGLE = '.menu-drawer__submenu-toggle';
  const ROW = 'summary.menu-drawer__menu-item--split';

  document.addEventListener(
    'click',
    (event) => {
      const target = event.target instanceof Element ? event.target : null;
      if (!target) return;

      const toggle = target.closest(TOGGLE);
      if (toggle) {
        event.preventDefault();
        event.stopPropagation();
        const details = toggle.closest('details');
        if (details) details.open = !details.open;
        return;
      }

      /* A click on the row that misses both the link and the button does nothing. */
      if (target.closest(ROW) && !target.closest('a')) event.preventDefault();
    },
    true
  );

  /* Keep aria-expanded in sync however the submenu is opened or closed. */
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      const toggle = details.querySelector(':scope > summary ' + TOGGLE);
      if (toggle) toggle.setAttribute('aria-expanded', String(details.open));
    },
    true
  );
})();